import React from 'react';
import ButtonHint from "../../../components/Buttons/buttonHint/ButtonHint";
import "./productOffersItemSyles.scss";

const ProductOffersItem = ({ item, onAnswerUpdate, colorClass }) => {

    const handleYesClick = () => {
        onAnswerUpdate(item.guid, true, false);
    };

    const handleNoClick = () => {
        onAnswerUpdate(item.guid, false, true);
    };

    return (
        <div className={`product_offers_page_item ${colorClass || ''}`}>
            <div className={"title"}>
                {item.good_name || "Не указан"}
            </div>

            <div className={"date_grid"}>
                <div className={"date_title"}>
                    Группа товара:
                    <span className={"date_value"}>{item.group_good_name || "Не указан"}</span>
                </div>

                <div className={"date_title"}>
                    Производитель:
                    <span className={"date_value"}>{item.producer_name || "Не указан"}</span>
                </div>

                <div className={"date_title"}>
                    Вид упаковки ед. товара:
                    <span className={"date_value"}>{item.type_package_good || "Не указан"}</span>
                </div>

                <div className={"date_title"}>
                    Ед. измерения:
                    <span className={"date_value"}>{item.unit_measure || "Не указан"}</span>
                </div>

                <div className={"date_title"}>
                    Средний вес ед. товара, кг:
                    <span className={"date_value"}>{item.avg_weight || "Не указан"}</span>
                </div>

                <div className={"date_title"}>
                    Норма отгрузки в ТТ, шт:
                    <span className={"date_value"}>{item.norm_shipment || "Не указан"}</span>
                </div>

                <div className={"date_title"}>
                    Срок годности, дни:
                    <span className={"date_value"}>{item.expiration_date || "Не указан"}</span>
                </div>

                <div className={"date_title"}>
                    Режим хранения:
                    <span className={"date_value"}>{item.temperature_mode || "Не указан"}</span>
                </div>

                <div className={"date_title"}>
                    ОСГ при поставке магазин, дни:
                    <span className={"date_value"}>{item.osg_expiration_date || "Не указан"}</span>
                </div>

                <div className={"date_title"}>
                    Цена полки в РС:
                    <span className={"date_value"}>{item.price || "Не указан"}</span>
                </div>

                <div className={"date_title"}>
                    Доставка:
                    <span className={"date_value"}>{item.freq_delivering || "Не указан"}</span>
                </div>
            </div>

            <div className={"buttons_wrapper"}>
                <ButtonHint
                    text={"Хочу"}
                    className={`but_yes ${item?.answer_no === true ? "button__disabled":""}`}
                    funck={handleYesClick}
                    isDisabled={item?.answer_yes === true}
                />
                <ButtonHint
                    text={"Не хочу"}
                    className={`but_no ${item?.answer_yes === true ? "button__disabled":""}`}
                    funck={handleNoClick}
                    isDisabled={item?.answer_no === true}
                />
            </div>
        </div>
    );
};

export default ProductOffersItem;